import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { environment } from '@environments/environment';

import { UtilitiyService } from './utility.service';

import { SearchedFile } from '@classes/wiki/searched-file.model';
import { TextToFind } from '@classes/wiki/text-to-find.model';

@Injectable({
  providedIn: 'root'
})
export class SearchedService {

  private textToFindSub = new Subject<TextToFind>();

  constructor(private httpClient: HttpClient, private utilityService: UtilitiyService) { }

  findFiles(text: TextToFind, provider: string = null): Observable<SearchedFile[]> {
    const encrypted = this.utilityService.encryptString(text.text);
    return this.httpClient.get<SearchedFile[]>(
      `${environment.apiUrl}/wiki/files?find=${encrypted}&option=${text.option}${provider ? `&provider=${provider}` : ''}`);
  }

  changeTextToFindSub(ttf: TextToFind): void {
    this.textToFindSub.next(ttf);
  }

  getTextToFindSub(): Observable<TextToFind> {
    return this.textToFindSub.asObservable();
  }
}
